import React from 'react'
import styles from './app_info_header.module.css'

export default function AppInfoHeaderChild(props) {

    return (
        <div className={`${props.css} ${styles.child_container}`}>
            <span className={styles.child_title}>{props.title}</span>
            <span className={styles.child_subTitle}>{props.subTitle}</span>
        </div>
    )
}